import axios from 'axios';
export const errCheck = (err) => {
    if (err.response.data.statusCode == '401') {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};
export default class InquiryService {
    // async getInquiryList(inqTitl, uid, nckName, contentype, sdate, edate, stat) {
    //     return await axios
    //         .post(`/inquiry/inquiryByperiod`, {
    //             inquiry_title: inqTitl,
    //             user_id: uid,
    //             nickname: nckName,
    //             type_id: contentype,
    //             from_date: sdate,
    //             to_date: edate,
    //             status: stat,
    //         })
    //         .then((res) => res.data)
    //         .catch((err) => {
    //             errCheck(err);
    //         });
    // }
    async getInquiryList(data) {
        return await axios .post('api/v1/admin/inquiry/list', data);
    }
    async getInquiryType() {
        return await axios
            .get(`/inquiry/inquiryType`)
            .then((res) => res.data.inquiryTypeData)
            .catch((err) => {
                errCheck(err);
            });
    }

    async inquiryReply(id , answer) {
        // console.log(ids)
        return await axios.post(`api/v1/admin/inquiry/reply`, { inquiry_id: id , answer:answer }).then((res) => res);
    } 
    // async inquiryReply(id, answer) {
    //     return await axios
    //         .post(`api/v1/admin/inquiry/reply/${id}`, {
    //             answer: answer,
    //         })
    //         .then((res) => res.data)
    //         .catch((err) => {
    //             errCheck(err);
    //         });
    // }
    // async addInquiryType(titl) {
    //     return await axios
    //         .post(`/inquery_type/add`, {
    //             title: titl,
    //             status: 'active',
    //         })
    //         .then((res) => res);
    // }
    // async viewInquiryType(ids) {
    //     return await axios
    //         .post(`/inquiry/inquiryType/${ids}`, {
    //             id: ids,
    //         })
    //         .then((res) => res.data);
    // }
    // async viewInquiry(ids) {
    //     return await axios
    //         .get(`/inquiry/inquiryDetails/${ids}`)
    //         .then((res) => res.data.data.reportData[0])
    //         .catch((err) => {
    //             errCheck(err);
    //         });
    // }
    async viewInquiry(ids) {
        return await axios
            .post(`api/v1/admin/inquiry/details`, {
                inquiry_id: ids,
            })
            .then((res) => res.data.result);
    }
    async getExcel(inqTitl, uid, nckName, contentype, sdate, edate, stat,dreason) {
        return await axios({
            url: `/inquiry/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                inquiry_title: inqTitl,
                user_id: uid,
                nickname: nckName,
                type_id: contentype,
                from_date: sdate,
                to_date: edate,
                status: stat,
                reason:dreason,
            },
        })
            .then((res) => res)
            .catch((err) => {
                errCheck(err);
            });
    }
}
